import { Component, Input } from '@angular/core';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { ICerere } from 'src/app/components/cereri/cereri.interface';

@Component({
    selector: 'app-subsemnat',
    templateUrl: './subsemnat.component.html',
    styleUrls: ['./subsemnat.component.scss'],
})
export class SubsemnatComponent {
    @Input() cerere!: ICerere;
    selectedSubsemnatulStatus = 'info';

    onSubsemnatulInfoChange(event: MatButtonToggleChange) {
        this.selectedSubsemnatulStatus = event.value;
    }

    formatDate(date: string): string {
        return new Date(date).toLocaleString('ro-RO');
    }
}
